import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';

// UTILITY
import { getS3ImageUrl } from '@/utility/content';

const tvImg = getS3ImageUrl('/free-tv/samsung-tv.png');
const tvImgX2 = getS3ImageUrl('/free-tv/samsung-tv-x2.png');

const Info = () => {
  const [t] = useTranslation();

  return (
    <div className="info section">
      <div className="page-content">
        <Typography
          className="section__title info__title"
          align="center"
          component="h2"
          variant="h3"
        >
          <Trans
            i18nKey="freeTv.info.title"
            components={{
              span: <span className="text-color--purple" />,
            }}
          />
        </Typography>
        <Typography className="info__subtitle body3 m-b-30" align="center">
          {t('freeTv.info.subtitle')}
        </Typography>
        <img className="info__img" srcSet={`${tvImgX2} 2x`} src={tvImg} alt="smart-tv" />
      </div>
    </div>
  );
};

export default React.memo(Info);
